<div class="backdrop" [class.show]="menuOpen" (click)="closeMenu.emit()"></div>
<aside class="sidebar" [class.open]="menuOpen" [class.collapsed]="isCollapsed">
  <div class="sidebar-header">
    <button
      type="button"
      class="collapse-btn"
      (click)="toggleCollapse()"
      [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-expanded]="!isCollapsed"
    >
      <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>

  <nav class="sidebar-nav" aria-label="Main navigation">
    <div class="nav-section">
      <span class="section-label">MAIN</span>
      @for (item of navItems; track item.label) {
        @if (item.children && item.children.length > 0) {
          <!-- Parent item with submenu -->
          <div class="nav-item-group">
            <a
              class="nav-item parent"
              [class.expanded]="isExpanded(item.label)"
              [class.has-active-child]="hasActiveChild(item)"
              (click)="toggleExpand(item.label, $event)"
              [attr.aria-label]="item.label"
              role="button"
              [attr.aria-expanded]="isExpanded(item.label)"
            >
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
              <span class="nav-label">{{ item.label }}</span>
              <mat-icon class="expand-icon">{{ isExpanded(item.label) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </a>
            @if (isExpanded(item.label)) {
              <div class="submenu">
                @for (child of item.children; track child.route) {
                  <a
                    class="nav-item child"
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="closeMenu.emit()"
                    [attr.aria-label]="child.label"
                  >
                    <mat-icon class="nav-icon">{{ child.icon }}</mat-icon>
                    <span class="nav-label">{{ child.label }}</span>
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <!-- Single item without submenu -->
          <a
            class="nav-item"
            [routerLink]="item.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
            (click)="closeMenu.emit()"
            [attr.aria-label]="item.label"
          >
            <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            <span class="nav-label">{{ item.label }}</span>
          </a>
        }
      }
    </div>
  </nav>
</aside>
